import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";

import { Who5Update } from "./Who5Update";
import { Who5Delete } from "./Who5Delete";

export function Who5Edit(props) {
  const who5 = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = who5.message;

  const [who5ErrorMessage, setWho5ErrorMessage] = useState("");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const [who5Resp, setWho5Resp] = useState(who5.meta?.who5Resp);
  const [metaFecha, setWho5Fecha] = useState(who5.meta?.metaFecha);

  const [who5Alegre, setWho5Alegre] = useState(who5.meta?.who5Alegre);
  const [who5Tranquilo, setWho5Tranquilo] = useState(who5.meta?.who5Tranquilo);
  const [who5Activo, setWho5Activo] = useState(who5.meta?.who5Activo);
  const [who5Despejado, setWho5Despejado] = useState(who5.meta?.who5Despejado);
  const [who5Interesan, setWho5Interesan] = useState(who5.meta?.who5Interesan);

  // Sum of all WHO-5 test responses
  const totalSumWho5 =
    4 *
    ((parseInt(who5Alegre) || 0) +
      (parseInt(who5Tranquilo) || 0) +
      (parseInt(who5Activo) || 0) +
      (parseInt(who5Despejado) || 0) +
      (parseInt(who5Interesan) || 0));

  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let who5Id = who5.id;

  const who5Date = new Date(who5.date);
  const diffDate = Math.abs(new Date() - who5Date) / 36e5;

  const submitWho5 = async (e) => {
    e.preventDefault();
    setWho5ErrorMessage("");     // Limpiar el mensaje de error previo
    setIsErrorModalOpen(false);
    setIsCreatingButton(true);
    try {

      // Crear un array con las 5 respuestas
    const who5Answers = [
      who5Alegre,
      who5Tranquilo,
      who5Activo,
      who5Despejado,
      who5Interesan,
    ];
    
    // Contar cuántas están respondidas
    const answeredQuestions = who5Answers.filter((val) => val !== "").length;
    const totalQuestions = who5Answers.length;
    const percentage = (answeredQuestions / totalQuestions) * 100;

    // Si no se ha respondido el 100% de preguntas, mostrar error
    if (percentage < 100) {
      setWho5ErrorMessage(
        "Para que podamos trabajar en tu recuperación y bienestar, necesitamos tus respuestas en todas las preguntas."
      );
      setIsErrorModalOpen(true);
      setIsCreatingButton(false);
      return; // Evitar el envío del formulario
    }


      await Who5Update(
        who5Resp,
        metaFecha,
        who5Alegre,
        who5Tranquilo,
        who5Activo,
        who5Despejado,
        who5Interesan,
        tratamientoId,
        pacienteId,
        who5Id
      ).then(
        (val) => {
          navigate(`../${tratamientoId}/cuestionarios/who5/${who5Id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await Who5Delete(who5Id).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
      {/* Modal de Error */}
      {isErrorModalOpen && (
          <div className={`modal ${isErrorModalOpen ? "is-active" : ""}`}>
            <div
              className="modal-background"
              onClick={() => setIsErrorModalOpen(false)}
            ></div>
            <div className="modal-card">
              <header className="modal-card-head">
                <p className="modal-card-title">Algo salió mal...</p>
                <button
                  className="delete"
                  aria-label="close"
                  onClick={() => setIsErrorModalOpen(false)}
                ></button>
              </header>
              <section className="modal-card-body">{who5ErrorMessage}</section>
              <footer className="modal-card-foot">
                <button
                  className="button is-danger"
                  onClick={() => setIsErrorModalOpen(false)}
                >
                  Cerrar
                </button>
              </footer>
            </div>
          </div>
        )}
        {who5.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form
            id='formUpdatelement'
            className='newRadioButtons'
            onSubmit={submitWho5}
          >
            <fieldset id='disabledContainer'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='who5Resp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='who5Resp'
                      required
                      type='text'
                      value={who5Resp}
                      onChange={(e) => setWho5Resp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='metaFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='metaFecha'
                      required
                      type='date'
                      value={metaFecha}
                      onChange={(e) => setWho5Fecha(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h3>Cuestionario WHO-5</h3>

              <div className='form-radio-container'>
                <div className='grid--2-col'>
                  <div className='radio-capt radio--6-col'>
                    <p>Todo el tiempo</p>
                    <p>La mayor parte del tiempo</p>
                    <p>Más de la mitad del tiempo</p>
                    <p>Menos de la mitad del tiempo</p>
                    <p>Algo del tiempo</p>
                    <p>En ningún momento</p>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='who5Alegre'>
                      1. me he sentido alegre y con buen ánimo
                    </label>
                    <div className='radio--6-col'>
                      <label className='radio' htmlFor='who5Alegre-5'>
                        <input
                          id='who5Alegre-5'
                          name='who5Alegre'
                          type='radio'
                          value='5'
                          checked={who5Alegre === "5"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        5
                      </label>
                      <label className='radio' htmlFor='who5Alegre-4'>
                        <input
                          id='who5Alegre-4'
                          name='who5Alegre'
                          type='radio'
                          value='4'
                          checked={who5Alegre === "4"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        4
                      </label>
                      <label className='radio' htmlFor='who5Alegre-3'>
                        <input
                          id='who5Alegre-3'
                          name='who5Alegre'
                          type='radio'
                          value='3'
                          checked={who5Alegre === "3"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='who5Alegre-2'>
                        <input
                          id='who5Alegre-2'
                          name='who5Alegre'
                          type='radio'
                          value='2'
                          checked={who5Alegre === "2"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='who5Alegre-1'>
                        <input
                          id='who5Alegre-1'
                          name='who5Alegre'
                          type='radio'
                          value='1'
                          checked={who5Alegre === "1"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='who5Alegre-0'>
                        <input
                          id='who5Alegre-0'
                          name='who5Alegre'
                          type='radio'
                          value='0'
                          checked={who5Alegre === "0"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='who5Tranquilo'>
                      2. me he sentido tranquilo y relajado
                    </label>
                    <div className='radio--6-col'>
                      <label className='radio' htmlFor='who5Tranquilo-5'>
                        <input
                          id='who5Tranquilo-5'
                          name='who5Tranquilo'
                          type='radio'
                          value='5'
                          checked={who5Tranquilo === "5"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        5
                      </label>
                      <label className='radio' htmlFor='who5Tranquilo-4'>
                        <input
                          id='who5Tranquilo-4'
                          name='who5Tranquilo'
                          type='radio'
                          value='4'
                          checked={who5Tranquilo === "4"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        4
                      </label>
                      <label className='radio' htmlFor='who5Tranquilo-3'>
                        <input
                          id='who5Tranquilo-3'
                          name='who5Tranquilo'
                          type='radio'
                          value='3'
                          checked={who5Tranquilo === "3"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='who5Tranquilo-2'>
                        <input
                          id='who5Tranquilo-2'
                          name='who5Tranquilo'
                          type='radio'
                          value='2'
                          checked={who5Tranquilo === "2"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='who5Tranquilo-1'>
                        <input
                          id='who5Tranquilo-1'
                          name='who5Tranquilo'
                          type='radio'
                          value='1'
                          checked={who5Tranquilo === "1"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='who5Tranquilo-0'>
                        <input
                          id='who5Tranquilo-0'
                          name='who5Tranquilo'
                          type='radio'
                          value='0'
                          checked={who5Tranquilo === "0"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='who5Activo'>
                      3. me he sentido activo y con energía
                    </label>
                    <div className='radio--6-col'>
                      <label className='radio' htmlFor='who5Activo-5'>
                        <input
                          id='who5Activo-5'
                          name='who5Activo'
                          type='radio'
                          value='5'
                          checked={who5Activo === "5"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        5
                      </label>
                      <label className='radio' htmlFor='who5Activo-4'>
                        <input
                          id='who5Activo-4'
                          name='who5Activo'
                          type='radio'
                          value='4'
                          checked={who5Activo === "4"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        4
                      </label>
                      <label className='radio' htmlFor='who5Activo-3'>
                        <input
                          id='who5Activo-3'
                          name='who5Activo'
                          type='radio'
                          value='3'
                          checked={who5Activo === "3"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='who5Activo-2'>
                        <input
                          id='who5Activo-2'
                          name='who5Activo'
                          type='radio'
                          value='2'
                          checked={who5Activo === "2"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='who5Activo-1'>
                        <input
                          id='who5Activo-1'
                          name='who5Activo'
                          type='radio'
                          value='1'
                          checked={who5Activo === "1"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='who5Activo-0'>
                        <input
                          id='who5Activo-0'
                          name='who5Activo'
                          type='radio'
                          value='0'
                          checked={who5Activo === "0"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='who5Despejado'>
                      4. me he despertado sintiéndome despejado y descansado
                    </label>
                    <div className='radio--6-col'>
                      <label className='radio' htmlFor='who5Despejado-5'>
                        <input
                          id='who5Despejado-5'
                          name='who5Despejado'
                          type='radio'
                          value='5'
                          checked={who5Despejado === "5"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        5
                      </label>
                      <label className='radio' htmlFor='who5Despejado-4'>
                        <input
                          id='who5Despejado-4'
                          name='who5Despejado'
                          type='radio'
                          value='4'
                          checked={who5Despejado === "4"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        4
                      </label>
                      <label className='radio' htmlFor='who5Despejado-3'>
                        <input
                          id='who5Despejado-3'
                          name='who5Despejado'
                          type='radio'
                          value='3'
                          checked={who5Despejado === "3"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='who5Despejado-2'>
                        <input
                          id='who5Despejado-2'
                          name='who5Despejado'
                          type='radio'
                          value='2'
                          checked={who5Despejado === "2"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='who5Despejado-1'>
                        <input
                          id='who5Despejado-1'
                          name='who5Despejado'
                          type='radio'
                          value='1'
                          checked={who5Despejado === "1"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='who5Despejado-0'>
                        <input
                          id='who5Despejado-0'
                          name='who5Despejado'
                          type='radio'
                          value='0'
                          checked={who5Despejado === "0"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='who5Interesan'>
                      5. mi vida diaria se ha llenado de cosas que me interesan
                    </label>
                    <div className='radio--6-col'>
                      <label className='radio' htmlFor='who5Interesan-5'>
                        <input
                          id='who5Interesan-5'
                          name='who5Interesan'
                          type='radio'
                          value='5'
                          checked={who5Interesan === "5"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        5
                      </label>
                      <label className='radio' htmlFor='who5Interesan-4'>
                        <input
                          id='who5Interesan-4'
                          name='who5Interesan'
                          type='radio'
                          value='4'
                          checked={who5Interesan === "4"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        4
                      </label>
                      <label className='radio' htmlFor='who5Interesan-3'>
                        <input
                          id='who5Interesan-3'
                          name='who5Interesan'
                          type='radio'
                          value='3'
                          checked={who5Interesan === "3"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='who5Interesan-2'>
                        <input
                          id='who5Interesan-2'
                          name='who5Interesan'
                          type='radio'
                          value='2'
                          checked={who5Interesan === "2"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='who5Interesan-1'>
                        <input
                          id='who5Interesan-1'
                          name='who5Interesan'
                          type='radio'
                          value='1'
                          checked={who5Interesan === "1"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='who5Interesan-0'>
                        <input
                          id='who5Interesan-0'
                          name='who5Interesan'
                          type='radio'
                          value='0'
                          checked={who5Interesan === "0"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className='form-results form-results-new form-results-audit'>
                <h3>Resultados de la autoevaluación WHO 5</h3>
                <p>Recuento total de puntos: {totalSumWho5}</p>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id='actions'>
          {(diffDate <= 72 || props.userRole.includes("administrador")) && (
            <button
              className='button is-link'
              id='saveButton'
              form='formUpdatelement'
              type='submit'
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
            </button>
          )}
          <Link
            className='button is-link is-light'
            to={`../${tratamientoId}/cuestionarios/who5/${who5.id}`}
          >
            Cancelar
          </Link>
          {props.userRole.includes("administrador") && (
            <button
              className='button is-danger'
              id='deleteButton'
              onClick={deleteItem}
              disabled={isDeletingButton}
            >
              {isDeletingButton ? <div className="spinner"></div> : "Eliminar"}
            </button>
          )}
        </div>
      )}
    </>
  );
}
